import React, { ReactNode } from 'react'
import { Box } from '@mui/material'

export const BoxWrapper: React.FC<{ mt?: number; children: ReactNode }> = ({ children, mt = 0 }) => (
  <Box width={'100%'} mt={mt}>
    {children}
  </Box>
)
